module.exports = __webpack_public_path__ + "static/media/hamantash3.a89d90d8.png";